import { RouteRecordRaw } from 'vue-router'

const dashboardRoutes: RouteRecordRaw = {
  path: 'dashboard/:dashboardId?',
  name: 'Dashboard',
  component: () => import('./DashboardListing.vue'),
  meta: {
    title: 'Dashboard'
  }
}

export default dashboardRoutes
